@if (endorsementLocation) {
  <ng-container data-private>
    @switch (endorsementLocation.endorsementTypeCode) {
      @case ('SIGNATURE') {
        <app-signature-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
          [hideIfSigned]="hideIfSigned"
          [disableFocus]="isAttemptingEndorsement$ | async"
          [isEndorsementDisabled]="isEndorsementDisabled"
          (signEndorsement)="signEndorsement($event)"
          (eraseSignedEndorsement)="eraseSignedEndorsement($event)"
        [areAllEndorsementsSigned]="areAllEndorsementsSigned"></app-signature-endorsement>
      }
      @case ('INITIALS') {
        <app-initials-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
          [hideIfSigned]="hideIfSigned"
          [disableFocus]="isAttemptingEndorsement$ | async"
          [isEndorsementDisabled]="isEndorsementDisabled"
          (signEndorsement)="signEndorsement($event)"
          (eraseSignedEndorsement)="eraseSignedEndorsement($event)"
        [areAllEndorsementsSigned]="areAllEndorsementsSigned"></app-initials-endorsement>
      }
      @case ('NOTARYSTAMP') {
        <app-stamp-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
          [disableFocus]="isAttemptingEndorsement$ | async"
          [isEndorsementDisabled]="isEndorsementDisabled"
          (signEndorsement)="signEndorsement($event)"
        [areAllEndorsementsSigned]="areAllEndorsementsSigned"></app-stamp-endorsement>
      }
      @case ('TEXTBOX') {
        <app-free-text-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
          [disableFocus]="isAttemptingEndorsement$ | async"
          [isEndorsementDisabled]="isEndorsementDisabled"
          (signEndorsement)="signEndorsement($event)"
          (eraseSignedEndorsement)="eraseSignedEndorsement($event)"
        [areAllEndorsementsSigned]="areAllEndorsementsSigned"></app-free-text-endorsement>
      }
      @case ('CHECKBOX') {
        <app-checkbox-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
          [disableFocus]="isAttemptingEndorsement$ | async"
          [isEndorsementDisabled]="isEndorsementDisabled"
          (signEndorsement)="signEndorsement($event)"
          (eraseSignedEndorsement)="eraseSignedEndorsement($event)"
        [areAllEndorsementsSigned]="areAllEndorsementsSigned"></app-checkbox-endorsement>
      }
      @case ('STATE') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'State'"></app-system-endorsement>
      }
      @case ('DATE') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Date'"></app-system-endorsement>
      }
      @case ('PRINTEDNAME') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Printed name'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTNAME') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent name'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTCOUNTY') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent county'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTCOMMEXPIRE') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent commission expiration'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTCOMMNUMBER') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent commission number'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTCOMMSTATE') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent commission state'"></app-system-endorsement>
      }
      @case ('SIGNINGAGENTCOMMCOUNTY') {
        <app-system-endorsement
          [endorsementLocation]="endorsementLocation"
          [endorsementImage]="endorsementImage | async"
        [altText]="'Signing agent commission county'"></app-system-endorsement>
      }
      @default {
        <app-unsupported-endorsement
          [endorsementLocation]="endorsementLocation">
        </app-unsupported-endorsement>
      }
    }
  </ng-container>
}
